import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, FileInput, FormField, Grid, List, Select, Text, TextArea, TextInput, Image } from "grommet";
import { debounce, sum } from "lodash";
import * as React from "react";
import Avatar from "react-avatar";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";

import NavigateToPath from "../components/NavigateToPath";

import AllowedEntityTypesSelector from "./AllowedEntityTypesSelector";

import AllowedImageTypesSelector from "./AllowedImageTypesSelector";

import { newContentIcon } from "./ContentManagement";
import { ContentViewModel, CreateContent, CreateContentBulk, EntityTypes, ImageTypes } from "./ContentStore";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const xmark = <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>;

const FileReaderAsync = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            resolve(reader.result as string);
        };
        reader.onerror = reject;

        reader.readAsDataURL(file);
    });
};

const ContentCreate = ({ onCreated }: { onCreated: Function }) => {
    const [allowedTypes, setAllowedTypes] = React.useState(ImageTypes.All as ImageTypes);
    const [allowedEntities, setAllowedEntities] = React.useState(EntityTypes.All as EntityTypes);
    const [imageContent, setImageContent] = React.useState([] as string[]);
    const [name, setName] = React.useState("");

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    const navigate = useNavigate();

    let create = () => {
        setError("");
        setIsCreating(true);
        CreateContentBulk(imageContent.map((i) => ({ allowedTypes, allowedEntities, content: i, name }))).then(
            (result) => {
                onCreated();
                setIsCreating(false);
            },
            (error) => {
                setError(error);
            }
        );
    };

    return (
        <div>
            <Box direction="row">
                <h1>Create Content </h1>
                <NavigateToPath path="/content/create"></NavigateToPath>
            </Box>
            <Box width={{ max: "400px" }} pad="small" round="5px" background={"background"} gap="small">
                <FormField label="Name">
                    <TextInput value={name} onChange={(e) => setName(e.target.value)} disabled={isCreating} />
                </FormField>
                <Text>Confine to</Text>
                <AllowedImageTypesSelector imageType={allowedTypes} onChange={setAllowedTypes}></AllowedImageTypesSelector>
                <Text>Confine to</Text>
                <AllowedEntityTypesSelector entityType={allowedEntities} onChange={setAllowedEntities}></AllowedEntityTypesSelector>
                <FileInput
                    accept="image/*"
                    name="file"
                    multiple
                    onChange={(event) => {
                        if (event) {
                            setImageContent([]);
                            const fileList = event.target.files;
                            if (fileList && fileList.length > 0) {
                                if (sum(Array.from(fileList).map((f) => f.size)) > 10000000) {
                                    setError("Total file size too large, <10MB");
                                } else {
                                    Promise.all(Array.from(fileList).map((file) => FileReaderAsync(file))).then((results: string[]) => {
                                        setImageContent([...results]);
                                    });
                                }
                            }
                        }
                    }}
                />

                {imageContent.map((image, i) => (
                    <Image key={i} src={image} alt="" width={"350px"} fit="cover" />
                ))}

                <Box direction="row">
                    <CustomButton loading={isCreating} primary icon={newContentIcon} onClick={create} disabled={isCreating || !name || allowedTypes == ImageTypes.None} label="Create"></CustomButton>
                </Box>
                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default ContentCreate;
